/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import { graphql, useStaticQuery } from "gatsby";
import PropTypes from "prop-types";
import React from "react";
import { Helmet } from "react-helmet";
import favicon from "images/favicon.png";

const description =
  "初めてのネットショップ開設でも、簡単にスタートできます！決済手数料も安いので、売上が上がれば、利益も大きくなります！個人でも、法人でも、すぐに開業ができるので、コマチカートをご利用ください！";
const domain = `https://www.comachicart.jp`;

function SEO({ title, path = "", lang, meta }) {
  const { site } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          description
          author
        }
      }
    }
  `);
  const type = path?.includes("?id=") ? "article" : "website";
  const url = path ? domain + "/" + path : domain;
  const metaDescription = description;
  const defaultTitle = site.siteMetadata?.title;
  const isNoIndex = process.env.GATSBY_NOINDEX === "true";
  
  return (
    <Helmet
      htmlAttributes={{ lang }}
      title={title}
      titleTemplate={defaultTitle ? `%s | ${defaultTitle}` : null}
      meta={[
        ...(isNoIndex
          ? [{ name: "robots", content: "noindex,nofollow" }]
          : []),
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: type,
        },
        {
          property: `og:url`,
          content: url,
        },
        {
          property: `og:site_name`,
          content: `無料で決済手数料が安いネットショップ作成・開設ならコマチカート`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata?.author || ``,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ].concat(meta)}
    >
    <link rel="icon" type="image/png" href={favicon} />
  </Helmet>
  );
}

SEO.defaultProps = {
  lang: `ja`,
  meta: [],
  description: ``,
};

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
};

export default SEO;
